import { ViewController } from 'ionic-angular';
import { Component } from '@angular/core';

/**
 * This component will be responsible for showing a list of suppliers.
 */
@Component({
  selector: 'supplier-list-modal',
  templateUrl: 'supplier-list-modal.html'
})
export class SupplierListModalComponent {

  constructor(private viewCtrl: ViewController) { }

  /**
   * Called whenever an item in the list is selected.
   * @param supplierId {number} the id of the supplier
   */
  public onSelect(supplierId: number) {
    console.log('[supplier-list-modal] supplierId is', supplierId);
    this.viewCtrl.dismiss(supplierId);
  }

  /**
   * Called whenever the modal close button is clicked.
   */
  public dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/modules/supplier-selector/supplier-list-modal/supplier-list-modal.ts